import {
  useState,
  useEffect
} from 'react'

const useMouse = () => {
  const [mousePos, setMousePos] = useState({})

  useEffect(() => {
    const getMousePos = e => {
      const posX = e.clientX
      const posY = e.clientY
      setMousePos({
        posX, posY
      })
    }

    document.addEventListener('mousemove', getMousePos)

    return function cleanup() {
      document.removeEventListener('mousemove', getMousePos)
    }
  })
  return {
    mousePos,
    // mouseVisible
  }
}

export default useMouse
